import Vue from 'vue'
import Router from 'vue-router'

import { store } from '../main.js'

// import Login from './login'
import LoginEmail from './loginEmail'
import Home from './home'
import Research from './research'

Vue.use(Router);

const router = new Router({
    mode: 'history',
    linkActiveClass: "active",
    hashbang: false,
    routes: [
        // Login,
        Home,
        Research,
        LoginEmail
    ]
});

router.beforeEach((to, from, next) => {
    const authenticated = localStorage.getItem('token');

    if (!authenticated && to.path.toString() != '/login' && to.path.toString() != '/login-email') {
        next('/login');

        return true;
    }

    if (authenticated && to.path.toString() == '/login' && to.path.toString() != '/login-email') {
        next('/');

        return true;
    }

    next();
});

router.afterEach((to, from) => {
    let _name = to.name;
    let _route = to.fullPath;

    if (_name === 'Home') {
        _name = '';
        _route = '';
    }

    store.commit("updateBreadCrumbs", { name: _name, route: _route })
});

export default router



// WEBPACK FOOTER //
// ./src/router/index.js